import { render } from "./InvitacionesView.vue?vue&type=template&id=4bbc7a86&ts=true"
import script from "./InvitacionesView.vue?vue&type=script&lang=ts"
export * from "./InvitacionesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__